// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ep-modal[data-v-701ac82d] {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1032;\n}\n.ep-modal-backdrop[data-v-701ac82d] {\n  background: rgba(0, 0, 0, 0.75);\n  position: fixed;\n  z-index: 1031;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
